import { useEffect } from "react";
import AOS from "aos";

import aboutimg from "../../assets/img/aboutimg.png";
import Shake from "react-reveal/Shake";

const AboutCephasKids = () => {
  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <section className="lg:py-16 md:py-20 py-24 overflow-hidden bg-gradient-to-r from-[#FF4B010D]/5 via-[#FF4B010D]/5 to-[#1132961A]/10 lg:px-20 md:px-10 px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Column: Image Cluster */}
        <div className="relative w-full mx-auto lg:mx-0">
          {/* Central Image */}
          {/* <img
            data-aos="zoom-in"
            data-aos-duration="2000"
            data-aos-delay="200"
            src={imgseven || "/placeholder.svg"}
            alt="Central kid learning"
            className="rounded-full object-cover lg:w-[199.06px] lg:h-[182.62px] md:w-[190px] md:h-[180px] w-[150px] h-[142px] shadow-lg z-10"
            style={{
              position: "absolute",
              top: "50%",
              left: "45%",
              transform: "translate(-50%, -50%)",
            }}
          /> */}

          {/* First image - TOP of center */}
          {/* <img
            data-aos="fade-down"
            data-aos-duration="1500"
            data-aos-delay="400"
            src={imgone || "/placeholder.svg"}
            alt="Kid with glasses"
            className="absolute rounded-full object-cover w-[122.95px] h-[112.798px] shadow-md z-5"
            style={{
              top: "calc(50% - 150px)",
              left: "calc(20% + 75px)",
              transform: "translate(-50%, -50%)",
            }}
          /> */}

          {/* Second image - TOP RIGHT */}
          {/* <img
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-delay="600"
            src={imgtwo || "/placeholder.svg"}
            alt="Kid with headphones"
            className="absolute rounded-full object-cover w-[140.51px] h-[128.91px] shadow-md z-5"
            style={{
              top: "calc(50% - 100px)",
              left: "calc(50% + 110px)",
              transform: "translate(-50%, -50%)",
            }}
          /> */}

          {/* Third image - LEFT side */}
          {/* <img
            data-aos="fade-right"
            data-aos-duration="1500"
            data-aos-delay="800"
            src={imgsix || "/placeholder.svg"}
            alt="Girl with laptop"
            className="absolute rounded-full object-cover w-[93.67px] h-[85.94px] shadow-md z-5"
            style={{
              top: "50%",
              left: "calc(50% - 165px)",
              transform: "translate(-50%, -50%)",
            }}
          /> */}

          {/* Fourth image - RIGHT side */}
          {/* <img
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-delay="1000"
            src={imgfour || "/placeholder.svg"}
            alt="Boy with glasses"
            className="absolute rounded-full object-cover w-[122.95px] h-[112.79px] shadow-md z-5"
            style={{
              top: "50%",
              left: "calc(48% + 145px)",
              transform: "translate(-50%, -5%)",
            }}
          /> */}

          {/* Fifth image - BOTTOM LEFT */}
          {/* <img
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="1200"
            src={imgfive || "/placeholder.svg"}
            alt="Girl with laptop bottom"
            className="absolute rounded-full object-cover w-[93.67px] h-[85.94px] shadow-md z-5"
            style={{
              top: "calc(40% + 155px)",
              left: "calc(45% - 85px)",
              transform: "translate(-50%, -50%)",
            }}
          /> */}

          {/* Sixth image - BOTTOM RIGHT */}
          {/* <img
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="1400"
            src={imgthree || "/placeholder.svg"}
            alt="Boy with laptop bottom"
            className="absolute rounded-full object-cover w-[122.95px] h-[112.91px] shadow-md z-5"
            style={{
              top: "calc(50% + 150px)",
              left: "calc(50% + 35px)",
              transform: "translate(-50%, -50%)",
            }}
          /> */}
          <img
            data-aos="zoom-in"
            data-aos-duration="2000"
            src={aboutimg}
            alt=""
          />
        </div>

        {/* Right Column: Text Content */}
        <div className="text-[#1B1B1B] lg:pl-12">
          <Shake>
            <h2
              data-aos="fade-left"
              data-aos-duration="1000"
              className="text-3xl md:text-4xl font-bold font-DM_SANS mb-6  leading-tight"
            >
              Get to know the Heart of <br />
              <span className="text-[#FF4B01]">Cephas Kids </span>
              <span>Tech Xtra</span>
            </h2>
          </Shake>

          <p
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
            className="text-lg text-[#475569] font-DM_SANS font-normal mb-4 leading-relaxed"
          >
            It's not just tech skills we build; it's confidence, creativity, and
            a deep love for learning.
          </p>
          <p
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="400"
            className="text-lg text-[#475569] font-DM_SANS font-normal mb-4 leading-relaxed"
          >
            At Cephas Kids Tech Xtra, we help children see possibilities,
            explore new worlds, and grow into creators who aren't afraid to
            lead, build, and dream big.
          </p>
          <p
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="600"
            className="text-lg text-[#475569] font-DM_SANS font-normal"
          >
            We build their tech skills
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutCephasKids;
